import { CampaignCallAction, CampaignCallOutcome, CampaignCallStatus } from '../../model/campaign'

export const mapCallOutcomeFromRawData = (rawData: any): CampaignCallOutcome => ({
  callFeedback: rawData.CallFeedback,
  callStatus: rawData.CallStatus || CampaignCallStatus.New,
  callAction: rawData.CallAction || CampaignCallAction.None,
  campaignId: rawData.CampaignId,
  callingListId: rawData.CallingListId,
  entryId: rawData.EntryId,
  isCallBack: rawData.IsCallBack,
  isOpportunityIdentified: rawData.IsOpportunityIdentified,
  modified: rawData.Modified,
  modifiedBy: rawData.ModifiedBy,
  partnerId: rawData.PartnerId,
  locationId: rawData.LocationId,
  isr: rawData.ISR,
  created: rawData.Created,
  campaignTitle: rawData.CampaignTitle ?? undefined,
  campaignMsFormsUrl: rawData.CampaignMsFormsUrl ?? undefined,
})
